// Почта в шапке игры: число всего нового во всех разделах почты (письма и чаты, новости, заявки в друзья)
// и мигание; в каком разделе новое — видно по подсвеченным вкладкам на странице почты.
import { useMailCounts } from '@/lib/mailCounts';
import { IconButton } from '@/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function NotificationBell() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const counts = useMailCounts();
  const count = counts.total;
  // Открыть сразу тот раздел, где новое (если оно только в одном)
  const only = [
    ['mail', counts.mail],
    ['news', counts.news],
    ['friends', counts.friends],
  ].filter(([, n]) => Number(n) > 0);
  const path = only.length === 1 && only[0][0] !== 'mail' ? `/game/mail?tab=${only[0][0]}` : '/game/mail';
  return (
    <IconButton
      icon="mail"
      label={count > 0 ? t('game:mail.unreadLabel', { n: count }) : t('menu.mail')}
      onClick={() => navigate(path)}
      iconSize={22}
      badge={count || undefined}
      className={`!h-10 !w-10 text-parchment-100 ${count > 0 ? 'mail-unread-blink' : ''}`}
    />
  );
}
